// Use sandbox key for TikTok audit; switch to production key after approval
export const TIKTOK_CLIENT_KEY = 'sbawwlhcce2r7eulg2';
export const TIKTOK_REDIRECT_URI = 'https://toldfel.hu';
export const TIKTOK_SCOPES = 'user.info.basic,video.publish';
